module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _vm._v("Take Off Your Shoes")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("One Man’s Journey from the Boardroom to Bali and Back")]), _vm._v(" "), _c('h1', {
    staticClass: "bk2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "100",
      "src": "images/rbg-feder-mask.jpg",
      "width": "114"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Ben Feder")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("Radius Book Group")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("New York")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098afc90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rbgfeder0003.vue
// module id = 60
// module chunks = 0